import { State } from "@progress/kendo-data-query";
import { toast } from "react-toastify";
import { faRefresh, faSave } from "@fortawesome/free-solid-svg-icons";
import useLocalStorageGridState from "./UseLocalStorageGridState";
import PageMenuItem from "../Layout/PageMenu/PageMenuItem";
import StyledPageMenuIcon from "../Layout/PageMenu/PageMenuIcon";

interface StatePersistenceButtonsProps {
  readonly localStorageKey: string;
  readonly initialState: State;
  readonly dataState: State;
  readonly resetButtonText?: string;
  readonly saveButtonText?: string;
  readonly align?: "left" | "right";
}

function StatePersistenceButtons({
  localStorageKey,
  initialState,
  dataState,
  resetButtonText = "Reset to default",
  saveButtonText = "Save state",
  align = "right",
}: StatePersistenceButtonsProps) {
  const [, setSaveState] = useLocalStorageGridState(localStorageKey, initialState);

  function resetState() {
    setSaveState(initialState);
    window.location.reload();
  }

  function saveState() {
    setSaveState(dataState);
    toast("State saved", {
      type: "success",
    });
  }

  return (
    <div style={align === "left" ? { marginRight: "auto" } : {}}>
      <PageMenuItem align="right" onClick={() => resetState()} type="link">
        <StyledPageMenuIcon icon={faRefresh} />
        {resetButtonText}
      </PageMenuItem>
      <PageMenuItem align="right" onClick={() => saveState()} type="link">
        <StyledPageMenuIcon icon={faSave} />
        {saveButtonText}
      </PageMenuItem>
    </div>
  );
}

export default StatePersistenceButtons;
